export default __webpack_public_path__ + "static/media/image.soft-gallery-private-limited.bb1923e5.png";